import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicNominationDashboard({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 140 80"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g transform="translate(0 5)" fill="none" fillRule="evenodd">
        <path
          d="M130.547 75H68.81V38.774l-.284-.182 10.022-9.76a27.378 27.378 0 0118.935-7.8l18.422-.168.027.032 14.658 17.439-.043.482v36.185z"
          fill="#E3E8E8"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M80.438 27.7h36.923v1H80.438zM76.771 31.366h36.923v1H76.771z"
        />
        <path fill="#E3E8E8" d="M120.507 21.45h6.019v20.83h-6.019z" />
        <path
          d="M130.547 75H97.51V50.993a23.36 23.36 0 015.582-15.146l12.789-14.994 14.667 17.461V75z"
          fill="#D1D9D9"
        />
        <path
          fill="#FFF"
          d="M113.02 56.946h6.711v5.932h-6.711zM113.02 46.678h6.711v5.838h-6.711zM80.96 55.372h6.712v5.932H80.96zM80.96 45.104h6.712v5.838H80.96z"
        />
        <path fill="#E3E8E8" d="M71.086 10.023h7.304v25.282h-7.304z" />
        <path
          d="M83.253 75H8.357V31.04l-.334-.215.08-.076 13.679-13.325a27.626 27.626 0 0119.107-7.87l24.6-.224.027.031 17.787 21.16-.05.579V75z"
          fill="#E3E8E8"
        />
        <path
          d="M83.253 75H43.189V42.72a19.753 19.753 0 014.72-12.807L65.47 9.326l17.784 21.171V75z"
          fill="#D1D9D9"
        />
        <path fill="#FFF" d="M63.55 53.105h6.478v5.727h-6.479zM63.55 43.153h6.478v5.727h-6.479z" />
        <path fill="#FFF" fillRule="nonzero" d="M23.085 51.195h8.147v7.2h-8.147z" />
        <path fill="#FFF" d="M23.085 38.731h8.147v7.087h-8.147z" />
        <path fill="#333532" d="M0 74.735h140v1H0z" />
        <ellipse fill="#4557A1" cx={24.316} cy={55.552} rx={5.806} ry={11.846} />
        <path
          d="M24.852 74.942c-2.325-13.95-.023-27.852 0-27.99l.453.076c-.024.138-2.313 13.966 0 27.839l-.453.075z"
          fill="#8E9FCC"
        />
        <path
          fill="#8F9DD6"
          d="M24.177 55.812l5.25-2.808.216.404-5.25 2.809zM18.636 54.815l.217-.405 5.25 2.81-.217.405z"
        />
        <ellipse fill="#8F9DD6" cx={10.257} cy={47.214} rx={8.379} ry={17.096} />
        <path
          d="M11.19 75.172c-3.35-20.108-.033-40.142 0-40.342l.334.056c-.034.2-3.341 20.18 0 40.23l-.333.056z"
          fill="#666"
        />
        <path
          fill="#666"
          d="M10.133 47.733l7.577-4.053.16.299-7.577 4.053zM2.137 46.01l.16-.299 7.575 4.055-.16.299z"
        />
        <path
          d="M115.555 12.804l1.837-1.47c-1.427-.156-2.013.622-2.252 1.238-1.115-.463-2.329.143-2.329.143l3.675 1.334a2.78 2.78 0 00-.93-1.245zM82.364 1.49L84.201.02c-1.427-.157-2.013.621-2.252 1.237-1.115-.463-2.329.144-2.329.144l3.675 1.334a2.78 2.78 0 00-.93-1.245zM128.592 4.225l1.837-1.47c-1.427-.156-2.013.622-2.253 1.238-1.114-.463-2.328.143-2.328.143l3.675 1.334a2.78 2.78 0 00-.93-1.245zM50.517 72.427c-.489 0-.969.129-1.391.373a2.99 2.99 0 00-4.994 2.22H53.3a2.791 2.791 0 00-2.783-2.593zM98.202 72.427c-.489 0-.968.129-1.391.373a2.99 2.99 0 00-4.994 2.22h9.168a2.791 2.791 0 00-2.783-2.593zM74.712 70.426v.42h-2.24v3.99h-.42v-3.99H64.14v3.99h-.42v-3.99H61.69v-.42h13.022zm.026-1.257v.506H61.715v-.506h13.023zm0-1.05v.506H61.715v-.506h13.023zM122.397 70.426v.42h-2.24v3.99h-.42v-3.99h-7.911v3.99h-.42v-3.99h-2.031v-.42h13.022zm.026-1.257v.506H109.4v-.506h13.023zm0-1.05v.506H109.4v-.506h13.023z"
          fill="#333532"
        />
        <path
          fill="#E3E8E8"
          d="M70.096 23.352L68.53 19.72l-3.143.056-1.906 3.622.038.048h-.014v7.533h6.587v-7.533zM119.049 32.445l-1.266-2.655-2.54.04-1.54 2.648.03.035h-.01v5.506h5.322v-5.506z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M21 18.133h36.922v1H21zM17.332 21.8h36.924v1H17.332zM120.507 22.462h6.019v1h-6.019zM120.507 26.128h6.019v1h-6.019zM71.086 11.287h7.304v1h-7.304zM71.086 14.954h7.304v1h-7.304z"
        />
      </g>
    </svg>
  );
}

SvgPicNominationDashboard.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicNominationDashboard.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicNominationDashboard svgRef={ref} {...props} />
));
export default ForwardRef;
